import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { memberPortal } from "../member-portal";

export class memberEnrichVouchers {
	private enrichVchForm:any   = $('#miles-redeem-enrich-vouchers-form');
	private memberBase:any = new memberPortal();

	/**
	 * initialize all form inputs with focus and filled effects
	 * find all instances of text inputs in all 3 forms on page
	 * combine them into an array and apply effect to all fields
	 * @return {any} [description]
	 */
	initTextInputs(): any {
		let _self = this;
		let inputElArr:any = $.makeArray(_self.enrichVchForm.find('input[type="text"]'));

		_self.memberBase.initFormTextInputs(inputElArr);
	}

	/**
	 * [initSelectizeInputs description]
	 * @return {any} [description]
	 */
	initSelectizeInputs(): any {
		let _self = this;
		let countryInputNew = $('#redeem--new-address-country');
		let countryInput = $('#redeem--preferred-address-country');
		let getCountryOptions = $.Deferred();

		$.get('/content/dam/mas/json/countrycode.json')
		.done((data:any) => {
			let listItems = "<option value=''> </option>";
			for (let i = 0; i < data.Countries.length; i++) {
				listItems += "<option value='" + data.Countries[i].Code + "'>" + data.Countries[i].Name + "</option>";
			}
			getCountryOptions.resolve(listItems);
		})
		.fail((error:any) => {
			getCountryOptions.reject(error);
		});

		$.when(getCountryOptions).done(function(countryOptions:any) {
			countryInput.html(countryOptions);
			countryInputNew.html(countryOptions);
			let inputSelectArr = $.makeArray(_self.enrichVchForm.find('select'));
			_self.memberBase.initSelectizeInputs(inputSelectArr);
			_self.initFormLogic();
			_self.selectizeInputFieldsCustomValidation();
		});

	}

	/**
	 * [initPhoneInput description]
	 * @return {any} [description]
	 */
	initPhoneInput(): any {
		let _self = this;
		let phoneCodeInput = $('#redeem--preferred-address-phone-number-country-code');
		let phoneCodeInputNew = $('#redeem--new-address-phone-number-country-code');
		let getPhoneOptions = $.Deferred();

		$.get('/content/dam/mas/json/PhoneCode.json')
		.done((data:any) => {
			let listItems = "<option value=''> </option>";
			for (let i = 0; i < data.Phonecodes.length; i++) {
				listItems += "<option value='" + data.Phonecodes[i].Code + "'>" +data.Phonecodes[i].Code+"</option>";
			}
			getPhoneOptions.resolve(listItems);
		})
		.fail((error:any) => {
			getPhoneOptions.reject(error);
		});


		$.when(getPhoneOptions).done(function(titleOptions:any) {
			phoneCodeInput.html(titleOptions);
			phoneCodeInputNew.html(titleOptions);
			let inputElArr = $.makeArray(_self.enrichVchForm.find('.phoneinput'));
			_self.memberBase.initPhoneInput(inputElArr);
			// phone fields (allow integers only)
			$.each(inputElArr, function (i:number, el:any) {
				$(el).find('input[type="tel"]').attr({
					'data-parsley-type': 'integer'
				});
			});
		});

		// change phone number field validation message
		let phoneNumberFields = _self.enrichVchForm.find('.phoneinput input[type="tel"]');

		phoneNumberFields.each((i:number, el:any) => {
			$(el).attr({
				'data-parsley-type-message': 'This value should be a valid number.'
			});
		});
	}

	/**
	 * [initIncrementer description]
	 * @return {any} [description]
	 */
	initIncrementer(): any {
		let _self = this;
		let inputElArr:any = $.makeArray(_self.enrichVchForm.find('.incrementer'));

		_self.memberBase.initIncrementer(inputElArr);
	}

	initFormLogic(): any {
		let _self = this;
		let voucherIncrementer = _self.enrichVchForm.find('#redeem--vouchers-to-use');
		let voucherMilesInput = _self.enrichVchForm.find('#redeem--vouchers-required');
		let voucherSummaryInput = _self.enrichVchForm.find('#redeem--miles-used');
		let curMilesValue:number = 0;
		let totMilesValue:number = 0;
		let summaryVouchers = _self.enrichVchForm.find('#members-summary--vouchers-used');
		let summaryProcessing = _self.enrichVchForm.find('#members-summary--processing-fee');
		let summaryTotal = _self.enrichVchForm.find('#processing-summary-cash-miles');
		const milesUnit:number = parseInt($("#vouchercharge").val());
		let processingFee:number = parseInt($("#couriercharge").val());

		// diable input on voucherMilesInput
		voucherMilesInput.attr({
			'disabled': 'disabled'
		});

		// when incrementer value changes
		voucherIncrementer.on('incrementer.changed', function(e:any, val:any){
			if (!voucherMilesInput.hasClass('input-focused')) {
				voucherMilesInput.parent().addClass('input-focused');
				voucherMilesInput.parent().find('label').addClass('input-filled');
				voucherMilesInput.addClass('input-focused');
			}

			// update miles value used
			curMilesValue = val * milesUnit;
			voucherMilesInput.val(curMilesValue);

			summaryVouchers.find('.voucher-no-used').text(val);

			updateTotalTransactionSum();
		});

		// change processing fee based on country used
		let prefAddrCountry = _self.enrichVchForm.find('#redeem--preferred-address-country');
		let newAddrCountry = _self.enrichVchForm.find('#redeem--new-address-country');

		prefAddrCountry[0].selectize.on('change', (e:any, val:any) => {
				getNewProcessingFeeAndUpdateTotal(prefAddrCountry.val());
		});

		newAddrCountry[0].selectize.on('change', (e:any, val:any) => {
				getNewProcessingFeeAndUpdateTotal(newAddrCountry.val());
		});

		function updateTotalTransactionSum() {

			// update total miles value in summary
			// miles used + processing fee
			if (!voucherSummaryInput.hasClass('input-focused')) {
				voucherSummaryInput.parent().addClass('input-focused');
				voucherSummaryInput.parent().find('label').addClass('input-filled');
				voucherSummaryInput.addClass('input-focused');
			}

			totMilesValue = curMilesValue + processingFee;
			// update miles summary amount
			voucherSummaryInput.val(totMilesValue);

			summaryVouchers.fadeIn();
			summaryVouchers.find('.miles-amt-used').text(curMilesValue);
			summaryProcessing.fadeIn();
			summaryProcessing.find('.miles-amt-used').text(processingFee);
			summaryTotal.fadeIn();
			summaryTotal.find('#redeem--miles-used .amt').text(totMilesValue);
		}

		function getNewProcessingFeeAndUpdateTotal(country:string) {
      // do get request here
      // do your country processing fee here
      // check if processingFee has not been defined previously
      var data:any = {
      	'country': country
      };

      $.ajax({
      	type : 'POST',
      	url : '/bin/services/new/couriercharges',
      	data : data,
      	success : function(msg:any) {
      		_self.redirectUser(msg);
      		processingFee = parseInt(msg);
      		updateTotalTransactionSum();
      	},
      	error : function(error:any) {
      		processingFee = 0;
      		updateTotalTransactionSum();
      	}
      });
    }


		// each increment = 3500 miles / 50rm
		// processing fee = flat 750rm

		// link to
		// - miles req for redemption
		// - summary miles
		// - number in summary
		// - amt in summary
	}

	// toggle handler when changing address type
	// set whichever visible address field type to be required on display
	toggleAddressFields(): any {
		let _self = this;

		let preferredAddressTabContent: any = _self.enrichVchForm.find('a[href="#redeem--preferred-address"]');
		let newAddressTabContent: any = _self.enrichVchForm.find('a[href="#redeem--new-address"]');

		let preferredAddressInputs: any = {
			name: 	  _self.enrichVchForm.find('#redeem--preferred-address-name'),
			email: 	  _self.enrichVchForm.find('#redeem--preferred-address-email'),
			address:  _self.enrichVchForm.find('#redeem--preferred-address-address-line-1'),
			city: 	  _self.enrichVchForm.find('#redeem--preferred-address-city'),
			state:	  _self.enrichVchForm.find('#redeem--preferred-address-state'),
			cunCode:  _self.enrichVchForm.find('#redeem--preferred-address-phone-number-country-code'),
			phone: 	  _self.enrichVchForm.find('#redeem--preferred-address-phone-number'),
			country:  _self.enrichVchForm.find('#redeem--preferred-address-country')
		};

		let newAddressInputs: any = {
			name: 	  _self.enrichVchForm.find('#redeem--new-address-name'),
			email: 	  _self.enrichVchForm.find('#redeem--new-address-email'),
			address:  _self.enrichVchForm.find('#redeem--new-address-address-line-1'),
			city: 	  _self.enrichVchForm.find('#redeem--new-address-city'),
			state: 	  _self.enrichVchForm.find('#redeem--new-address-state'),
			cunCode:  _self.enrichVchForm.find('#redeem--new-address-phone-number-country-code'),
			phone: 	  _self.enrichVchForm.find('#redeem--new-address-phone-number'),
			country:  _self.enrichVchForm.find('#redeem--new-address-country')
		};

		let currAddressType:string;

		preferredAddressTabContent.on('show.bs.tab', function(e:any){
			currAddressType = 'preferred-address';
			_self.defaultAddressUsed(currAddressType);

			$.each(preferredAddressInputs, function(key:any, val:any){
				_self.addRequired(val);
			});

			$.each(newAddressInputs, function(key:any, val:any){
				_self.removeRequired(val);
			});
		});

		newAddressTabContent.on('show.bs.tab', function(e:any){
			currAddressType = 'new-address';
			_self.defaultAddressUsed(currAddressType);

			$.each(newAddressInputs, function(key:any, val:any){
				_self.addRequired(val);
			});

			$.each(preferredAddressInputs, function(key:any, val:any){
				_self.removeRequired(val);
			});
		});

	}

	toggleProcessingFields(): any {
		let _self = this;

		let rdmRadioCreditCard:any = _self.enrichVchForm.find('#redeem--pay-credit-card');
		let rdmRadioEnrichMiles:any = _self.enrichVchForm.find('#redeem--pay-enrich-miles');

		let rdmCashAmtInput:any = _self.enrichVchForm.find('#redeem--pay-cash-value');
		let rdmMilesAmtInput:any = _self.enrichVchForm.find('#redeem--pay-miles-value');

		// handle state on load
		handleRadioState();

		// handle state on change
		rdmRadioCreditCard.on('click', function(){
			handleRadioState();
		});

		rdmRadioEnrichMiles.on('click', function(){
			handleRadioState();
		});

		function handleRadioState() {
			if (rdmRadioCreditCard.prop('checked')) {

				rdmCashAmtInput.removeAttr('readonly');
				rdmMilesAmtInput.attr('readonly', 'readonly');
				_self.addRequired(rdmCashAmtInput);
				_self.removeRequired(rdmMilesAmtInput);

			} else if (rdmRadioEnrichMiles.prop('checked')) {

				rdmCashAmtInput.attr('readonly', 'readonly');
				rdmMilesAmtInput.removeAttr('readonly');
				_self.addRequired(rdmMilesAmtInput);
				_self.removeRequired(rdmCashAmtInput);

			}
		}
	}

	validateForm(): any {
		let _self = this;

		// init address type on load
		let startAddressType:string = 'preferred-address';
		_self.defaultAddressUsed(startAddressType);

		_self.memberBase.validateForm(_self.enrichVchForm, function(validation: any) {
			// all your custom validation here
			_self.selectizeInputFieldsCustomValidation();
		});
	}

	/**
	 * change required attribute of input field (remove)
	 *
	 * for selectize elements, go through this entire mess in order to make sure
	 * validation works correctly with parsley:
	 * - remove required class to pseudo text input
	 * - remove required attribute on pseudo text input
	 * - remove required attribute to <select> field
	 * @param {any} el [description]
	 */
	removeRequired(el:any) {
		let _this = $(el);
		_this.parent().find('label').removeClass('required');

		if (_this.hasClass('selectized')) {
			// console.log('%cremoveRequired =====', 'background-color: red; color: white; padding: 2px;');
			// console.log('%cselectized input element', 'color: red', _this);
			// console.log('%cselectized input text pseudo element', 'color: red', _this.next().find('.selectize-input'));
			// console.log('%c====================', 'background-color: red; color: white;');
			_this.next().find('.selectize-input').removeClass('required');
			_this.next().find('.selectize-input input').removeAttr('required');
			_this.next().find('.selectize-input input').parsley().destroy();
			_this.removeAttr('required');
			_this.parsley().destroy();
		} else {
			_this.removeAttr('required');
		}
	}

	/**
	 * change required attribute of input field (add)
	 *
	 * for selectize elements, go through this entire mess in order to make sure
	 * validation works correctly with parsley:
	 * - add required class to pseudo text input
	 * - but remove required attribute on pseudo text input (will never validate
	 *   since field is always empty on selection)
	 * - add required attribute to <select> field
	 * - for country code fields, change error container accordingly for correct placement
	 * @param {any} el [description]
	 */
	addRequired(el:any) {
		let _this = $(el);
		_this.parent().find('label').addClass('required');

		if (_this.hasClass('selectized')) {
			// console.log('%caddRequired ========', 'background-color: green; color: white; padding: 2px;');
			// console.log('%cselectized input element', 'color: green', _this);
			// console.log('%cselectized input text pseudo element', 'color: green', _this.next().find('.selectize-input'));
			_this.next().find('.selectize-input').addClass('required');
			_this.next().find('.selectize-input input').removeAttr('required');
			_this.attr('required', 'required');

			if (_this.attr('id').indexOf('country-code') > 0) {
				console.log('%cselectized input is countrycode', 'color: green');
				_this.attr('data-parsley-errors-container', '#' + _this.attr('id') + '--error-container');
			}
			console.log('%c====================', 'background-color: green; color: white; padding: 2px;');
		} else {
			_this.attr('required', 'required');
		}
	}

	defaultAddressUsed(currAddressType:string):any {
		let _self = this;
		let addressTypeInput:any = _self.enrichVchForm.find('#redeem--address-type');

		return addressTypeInput.val(currAddressType);
	}

	/**
	 * Nasty hack/workaround to fix selectize/parsley integration issue
	 * - refactor soon™
	 * adds a custom class 'has-sel-error' which manages error state of
	 * a selectized <select> element, toggling class on change & form submission.
	 * (also for non country-code select fields, toggle the 'has-error' class as well
	 * to handle the selectize fields on this page:
	 * - country code input
	 * - country input
	 * @return {any} [description]
	 */
	selectizeInputFieldsCustomValidation(): any {
		let _self = this;
		let _selectInputText:any = _self.enrichVchForm.find('.selectize-input input');
		let submitBtn:any        = _self.enrichVchForm.find('.btn-member--submit');

		submitBtn.on('click', () => {
			_selectInputText.each(function(){
				let _input  = $(this);
				let _select = _input.parents().eq(1).prev();
				let _pane   = _input.closest('.tab-pane');

				if (!_select.val() && _pane.hasClass('active')) {
					_select.closest('.form-item').addClass('has-sel-error');
				} else {
					_select.closest('.form-item').removeClass('has-sel-error');
				}
			});
		});

		_selectInputText.each(function(){
			let _input = $(this);
			let _select = _input.parents().eq(1).prev();
			let _parentFormItem = _select.closest('.form-item');

			_select.on('change', function(){
				console.log('changed', _select.val(), _parentFormItem);

				if (_select.val() && _parentFormItem.hasClass('has-sel-error')) {
					console.log('is an error field but is now filled');
					_parentFormItem.removeClass('has-sel-error');

					// for non country code selectize inputs,
					// handle the parsley error class as well
					if (_select.attr('id').indexOf('country-code') < 0) {
						console.log('not country code')
						_parentFormItem.removeClass('has-error');
					}
				}
			});
		});
	}

	prefillAddressForm(): void {
		let _self = this;
		var data = {
			'action': 'fetch'
		};

		$.ajax({
			type: 'POST',
			url:'/bin/services/new/enrichvoucher',
			data: data,
			success: function(msg:any) {
				var json = JSON.parse(msg);
				$("#redeem--preferred-address-name").val(json.firstName);
				$("#redeem--preferred-address-email").val(json.email);
				if(json.prefBus && json.prefBus == "T") {
					_self.fillBusinessAddress(json);
				} else {
					_self.fillHomeAddress(json);
				}
				_self.resetAllFields();
			},
			error:function(msg:any){}
		});
	}

	resetTheInputFieldUI(fieldElement:any):void {
		fieldElement.parent().find('label').addClass('input-filled');
		fieldElement.addClass('input-focused');
	}

	resetAllFields():void {
		let _self = this;
		_self.resetTheInputFieldUI($("#redeem--preferred-address-name"));
		_self.resetTheInputFieldUI($("#redeem--preferred-address-email"));
		_self.resetTheInputFieldUI($("#redeem--preferred-address-phone-number-country-code"));
		_self.resetTheInputFieldUI($("#redeem--preferred-address-phone-number"));
		_self.resetTheInputFieldUI($("#redeem--preferred-address-address-line-1"));
		_self.resetTheInputFieldUI($("#redeem--preferred-address-address-line-2"));
		_self.resetTheInputFieldUI($("#redeem--preferred-address-address-line-3"));
		_self.resetTheInputFieldUI($("#redeem--preferred-address-country"));
		_self.resetTheInputFieldUI($("#redeem--preferred-address-city"));
		_self.resetTheInputFieldUI($("#redeem--preferred-address-state"));
		_self.resetTheInputFieldUI($("#redeem--preferred-address-postcode"));
	}

	fillHomeAddress(json:any):void {
		$("#redeem--preferred-address-phone-number-country-code")[0].selectize.setValue(json.countryCodeHome);
		$("#redeem--preferred-address-phone-number").val(json.homeNumber);
		$("#redeem--preferred-address-address-line-1").val(json.homeAddress1);
		$("#redeem--preferred-address-address-line-2").val(json.homeAddress2);
		$("#redeem--preferred-address-address-line-3").val(json.homeAddress3);
		$("#redeem--preferred-address-country")[0].selectize.setValue(json.homeCountry);
		$("#redeem--preferred-address-city").val(json.homeCity);
		$("#redeem--preferred-address-state").val(json.homeState);
		$("#redeem--preferred-address-postcode").val(json.homePostCode);
	}

	fillBusinessAddress(json:any):void {
		$("#redeem--preferred-address-phone-number-country-code")[0].selectize.setValue(json.countryCodeOffice);
		$("#redeem--preferred-address-phone-number").val(json.businessNumber);
		$("#redeem--preferred-address-address-line-1").val(json.businessAddress1);
		$("#redeem--preferred-address-address-line-2").val(json.businessAddress2);
		$("#redeem--preferred-address-address-line-3").val(json.businessAddress3);
		$("#redeem--preferred-address-country")[0].selectize.setValue(json.businessCountry);
		$("#redeem--preferred-address-city").val(json.businessCity);
		$("#redeem--preferred-address-state").val(json.businessState);
		$("#redeem--preferred-address-postcode").val(json.businessPostCode);
	}

	redirectUser(msg:any):void {
		if(msg.indexOf("timeout") > -1) {
			msg = msg.replace("timeout-","");
			window.location.href = msg;
		}
	}


}

let scope:Element = document.querySelector('#miles-redeem-enrich-vouchers-form');

if (scope) {
	try {
	let memberenrichvouchers = new memberEnrichVouchers();
	memberenrichvouchers.initTextInputs();
	memberenrichvouchers.initSelectizeInputs();
	memberenrichvouchers.initPhoneInput();
	memberenrichvouchers.initIncrementer();
	memberenrichvouchers.toggleAddressFields();
	memberenrichvouchers.toggleProcessingFields();
	memberenrichvouchers.validateForm();
	memberenrichvouchers.prefillAddressForm();	
	} catch(e) {console.error(e);}
}
